import { create } from 'zustand';
import { SearchSortOrder } from '#server/models';

export interface SortOrderState {
  facetSortOrders: Record<string, SearchSortOrder | null>;
  currentFacet: string | null;
  currentSortOrderSet: SearchSortOrder[] | null;
  activeSortOrder: SearchSortOrder | null;
  actions: {
    setCurrentFacet: (facet: string, sortOrderSet: SearchSortOrder[]) => void;
    setActiveSortOrder: (sortOrder: SearchSortOrder | null) => void;
  };
}

export const useSortOrderStore = create<SortOrderState>((set, get) => ({
  facetSortOrders: {},
  currentFacet: null,
  currentSortOrderSet: null,
  activeSortOrder: null,
  actions: {
    setCurrentFacet: (facet, sortOrderSet) => {
      const { facetSortOrders } = get();
      const existing = facetSortOrders[facet] ?? null;

      set({
        currentFacet: facet,
        currentSortOrderSet: sortOrderSet,
        activeSortOrder: existing,
      });
    },

    setActiveSortOrder: (sortOrder) =>
      set((state) => {
        if (!state.currentFacet) return state;

        return {
          activeSortOrder: sortOrder,
          facetSortOrders: {
            ...state.facetSortOrders,
            [state.currentFacet]: sortOrder,
          },
        };
      }),
  },
}));

export const useSortOrderActions = () => useSortOrderStore((s) => s.actions);
